<template lang='pug'>
//- 飲食管家圖片辨識結果
div(:class='$style[`cc-popbox-diet-recognize`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='showLoading' :class='$style[`cc-content-recognize-result`]')
    div(:class='$style[`cc-content-recognize-loading`]')
      IconLoading(:size='50' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-content-recognize-result`]')
    div(:class='$style[`cc-content-recognize-name`]')
      span.font-bold {{ name }}

    section(:class='$style[`cc-content-recognize-info`]')
      //- figure(:class='$style[`cc-content-recognize-photo`]' :style='`background-image: url(${SERVER_STATIC_URL}media/${photo})`')
      figure(:class='$style[`cc-content-recognize-photo`]')
        img(:src='`${SERVER_STATIC_URL}media/${photo}`' :alt='name' width='100%')
        div(v-if='score <= 30' :class='[$style[`cc-content-recognize-score`], $style[`bad-status`]]')
          span.font-super-bold(:class='$style[`cc-content-recognize-score-value`]') {{ score }}
          span(:class='$style[`cc-content-recognize-score-tip`]') 推薦分數

        div(v-else-if='score > 30 && score <= 70' :class='[$style[`cc-content-recognize-score`], $style[`warn-status`]]')
          span.font-super-bold(:class='$style[`cc-content-recognize-score-value`]') {{ score }}
          span(:class='$style[`cc-content-recognize-score-tip`]') 推薦分數

        div(v-else-if='score > 70' :class='[$style[`cc-content-recognize-score`], $style[`good-status`]]')
          span.font-super-bold(:class='$style[`cc-content-recognize-score-value`]') {{ score }}
          span(:class='$style[`cc-content-recognize-score-tip`]') 推薦分數

      span.font-bold(:class='$style[`cc-content-recognize-score-describe`]') 推薦分數滿分100 (0分是完全不推薦、100分是非常推薦)

    section(:class='$style[`cc-content-recognize-comment`]')
      header.font-bold(:class='$style[`cc-content-recognize-header`]') 個人飲食建議
      div(:class='$style[`cc-content-recognize-comment-wrap`]')
        v-md-preview(:text='completion')

    section(:class='$style[`cc-content-recognize-info-nutritious`]')
      header.font-bold(:class='$style[`cc-content-recognize-header`]') 營養價值 (僅供參考)
      ul(:class='$style[`cc-content-recognize-info-nutritious-ul`]')
        li(v-for='item, index in nutritious' :key='index' :class='$style[`cc-content-recognize-info-nutritious-li`]')
          div(:class='[$style[`cc-content-recognize-info-nutritious-question`], $style[`flex-1`]]')
            span {{ item.item }}
          div(:class='[$style[`cc-content-recognize-info-nutritious-result`], $style[`flex-2`]]')
            span.font-bold {{ item.content ? item.content : '-' }}

    section(:class='$style[`cc-content-recognize-info-ingredient`]')
      header.font-bold(:class='$style[`cc-content-recognize-header`]') 食材成份
      ul(:class='$style[`cc-content-recognize-info-ingredient-ul`]')
        li(v-for='item, index in ingredient' :key='index' :class='$style[`cc-content-recognize-info-ingredient-li`]') {{ item }}

    section(:class='$style[`cc-content-recognize-recommend`]')
      header.font-bold(:class='$style[`cc-content-recognize-header`]') 推薦的替代食物
      ul(v-if='recommend' :class='$style[`cc-content-recognize-info-recommend-ul`]')
        li(v-for='item, index in recommend' :key='index' :class='$style[`cc-content-recognize-info-recommend-li`]') {{ item }}

    section(:class='$style[`cc-content-recognize-control`]')
      button.btn-extra(
        title='我知道了'
        tabindex='0' aria-label='我知道了'
        :class='$style[`cc-content-recognize-control-btn`]'
        @click='handleClosePopBox')
        span 我知道了

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// var emitter = require('tiny-emitter/instance');
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import IconVoice from '../../icon/Voice';
import IconLocker from '../../icon/Locker';
import IconThumb from '../../icon/Thumb';

// import { debounce } from 'debounce';
// import GlobalEmitter from 'tiny-emitter/instance';

// import {
//   postDietRecognize,
// } from '../../../js/restapi';

export default {
  components: {
    IconLoading,
    IconSearch,
    IconVoice,
    IconLocker,
    IconThumb,
  },

  props: {
    detail: {},
  },

  data() {
    return {
      showLoading: true,
      name: null,
      photo: null,
      ingredient: null,
      nutritious: null,
      completion: null,
      recommend: null,
      score: 0,
      create_date: null,
    };
  },

  mounted() {
    this.initDetailToJson();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDietRecognizeStatus: 'global/POPDIET_RECOGNIZE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopDietRecognizeStatus({
        active: false,
        detail: {},
      });
    },

    initDetailToJson() {
      const initProcess = new Promise((resolve) => {
        this.photo = this.detail.photo ? this.detail.photo : '';
        this.name = this.detail.name ? this.detail.name : '';
        this.ingredient = this.detail.ingredient ? this.detail.ingredient : [];
        this.nutritious = this.detail.nutritious ? this.detail.nutritious : [];
        this.recommend = this.detail.recommend ? this.detail.recommend : [];
        this.completion = this.detail.completion ? this.detail.completion : {};
        this.score = this.detail.score ? this.detail.score : 0;
        this.create_date = this.detail.date ? this.detail.date : null;
        console.log('CHECK ', this.detail, this.photo, this.name, this.ingredient, this.nutritious, this.completion, this.recommend, this.score);
        return resolve();
      });

      initProcess.then(() => {
        this.showLoading = false;
      });
    },

    // sendEvaluateForAnalysis(value) {
    //   const CONFIG = {
    //     analysis_id: this.detail.id,
    //     auth_id: this.loginDjangoId,
    //     evaluate: value,
    //   };

    //   putUserEvaluateAnalysis('', CONFIG)
    //     .then((res) => {
    //       this.evaluateValue = value;
    //       GlobalEmitter.emit('reload-analysis');
    //     })
    //     .catch((err) => {
    //       console.log('error');
    //     });
    // },

    // debounceSendEvaluate: debounce(async function(e) {
    //   this.sendEvaluateForAnalysis(e);
    // }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      // authJwtToken: 'user/exportUserJwtToken',
      loginStatus: 'user/exportLoginStatus',
      subscribeVip: 'user/exportUserSubscribeVip',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popDietRecognizeResult.scss';
</style>
